<prlw-modifiers-ui
  *ngIf="modifier$ | async as modifier"
  [modifier]="modifier"
  (prepaidMarginChange)="updatePrepaidMargin($event)"
  (deferChange)="updateDefer($event)"
></prlw-modifiers-ui>
